const {
    DEPOSIT_THIRTEEN_MONTHS_EXCEPTIONS_SECOND_RENEWAL,
    DEPOSIT_THIRTEEN_MONTHS_EXCEPTIONS, 
    HIRING_COMBINED_DEPOSITS,
    HIRING_EIGHTEEN_DEPOSITS_RETENTION,
    HIRING_TWENTYFOUR_DEPOSITS_RETENTION
} = require('constants/flagBasedFeatures');

const CC_DEPOSITS_PRODUCT_BANNERS = {
  //    'deposit13LeakRetention': {
  //        title: 'bannerDeposit13LeakRetention-title',
  //        link: '/myprofile/purchase/deposit-thirteen-months-leak-retention'
  //    }
    'deposit13Excepciones': {
        title: 'bannerDeposit13ExcepcionesNoVincAnd2ndRenova-bannerDeposit13ExcepcionesNoVincAnd2ndRenova_title',
        link: '/myprofile/purchase/deposit-thirteen-months-excepciones',
        featureFlag: DEPOSIT_THIRTEEN_MONTHS_EXCEPTIONS_SECOND_RENEWAL
    },
    'deposit13RenovacionExcepciones': {
        title: 'bannerDeposit13RenovacionExcepciones-bannerDeposit13RenovacionExcepciones_title',
        link: '/myprofile/purchase/deposit-thirteen-months-renovacion-excepciones',
        featureFlag: DEPOSIT_THIRTEEN_MONTHS_EXCEPTIONS
    },
    'deposit18Retention': {
        title: 'contractsView-contractsView_bannerDeposit18MonthsRetention_title',
        link: '/myprofile/purchase/deposit-eighteen-months-retention',
        featureFlag: HIRING_EIGHTEEN_DEPOSITS_RETENTION
    },
    'combinedDeposit': {
        title: 'contractsView-contractsView_combinedDepositStep1Title',
        link: '/myprofile/purchase/combined-deposit',
        featureFlag: HIRING_COMBINED_DEPOSITS
    },
    'deposit24Retention': {
        title: 'contractsView-contractsView_bannerDeposit24MonthsRetention_title',
        link: '/myprofile/purchase/deposit-twentyfour-months-retention',
        featureFlag: HIRING_TWENTYFOUR_DEPOSITS_RETENTION
    }
};

module.exports = CC_DEPOSITS_PRODUCT_BANNERS;
